import { RFResponse, RFResponseCommon } from "@/interfaces/common";
import {
  DepositRewardResponse,
  DepositRewardStockModel,
  MarqueeRecord,
  OpportunityRecord,
  PrizeRecord,
  ResponseInviteModel,
  ResponseRebateCommission,
} from "@/interfaces/pullNewType";
import * as http from "@/utils/request";
import rfStore from "@/utils/rfStore";
import useSWR from "swr";

const baseUrl = process.env.NEXT_PUBLIC_BASE_API;

const getOpenBrokerStatus = async () => {
  const url = `${baseUrl}/promotion/api/masterAccount/status/v2`;
  try {
    const { code, message, data } = await http.get<
      RFResponseCommon<{ masterAccountOpenStatus: number }>
    >(url);

    if (code !== 200) {
      throw Error(message);
    }

    console.log(data);
    return data.masterAccountOpenStatus;
  } catch (err) {
    throw err;
  }
};

// 邀请code
const getShareCode = async () => {
  const url = `${baseUrl}/promotion/api/invite/code`;
  try {
    const { code, message, data } = await http.get<RFResponseCommon<string>>(
      url
    );

    if (code !== 200) {
      throw Error(message);
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const useGetShareCode = () => {
  const uid = rfStore.getRFState()?.userId;

  const url = `${baseUrl}/promotion/api/invite/code`;
  const { data, mutate } = useSWR(
    uid ? url : null,
    async (url) =>
      await http.get<RFResponseCommon<string>>(url).then((res) => res.data)
  );

  return {
    loading: !data,
    shareCode: data,
    mutate,
  };
};

// 抽奖次数
const getPrizeTimes = async () => {
  const url = `${baseUrl}/promotion/api/invite/drawTimes`;

  try {
    const { code, message, data } = await http.get<RFResponseCommon<number>>(
      url
    );

    if (code !== 200) {
      throw Error(message);
    }

    console.log(data);

    return data;
  } catch (error) {
    console.log(error);
    return 0;
  }
};

// 获取抽奖结果
const getPrizeResult = async () => {
  const url = `${baseUrl}/promotion/api/spin`;

  try {
    const { code, message, data } = await http.post<
      null,
      RFResponseCommon<number>
    >(url);

    if (code !== 200) {
      throw Error(message);
    }

    return data;
  } catch (error) {
    console.log(error);
    return -1;
  }
};

// 获得机会记录列表
const getOpportunityRecords = async () => {
  const url = `${baseUrl}/promotion/api/invite/tasks?limit=50`;

  try {
    const { code, message, data } = await http.get<
      RFResponseCommon<OpportunityRecord[]>
    >(url);

    if (code !== 200) {
      throw Error(message);
    }

    console.log(data);

    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

// 抽奖记录
const getPrizeRecords = async () => {
  const url = `${baseUrl}/promotion/api/spin?limit=50`;

  try {
    const { code, message, data } = await http.get<
      RFResponseCommon<PrizeRecord[]>
    >(url);

    if (code !== 200) {
      throw Error(message);
    }

    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

// 轮播记录
const getMarqueeRecords = async () => {
  const url = `${baseUrl}/promotion/api/spin/marquee`;
  try {
    const { code, message, data } = await http.get<
      RFResponseCommon<MarqueeRecord[]>
    >(url);

    if (code !== 200) {
      throw Error(message);
    }

    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

// 获取邀请人
const getInviter = async (inviteCode: string) => {
  const url = `${baseUrl}/promotion/api/invite/getIdentities?inviteCode=${inviteCode}`;
  try {
    const { code, message, data } = await http.get<RFResponseCommon<string>>(
      url
    );

    if (code !== 200) {
      throw Error(message);
    }
    return data;
  } catch (error) {
    console.log("error: 获取邀请码的用户出错", error);
    throw error;
  }
};

// 获取邀请列表
export const useGetInvitees = () => {
  const uid = rfStore.getRFState()?.userId;
  const url = `${baseUrl}/promotion/api/invite/getInvitees`;
  const { data, mutate } = useSWR(
    uid ? url : null,
    async (url) =>
      await http
        .get<RFResponseCommon<ResponseInviteModel>>(url)
        .then((res) => res.data)
  );

  return {
    loading: !data,
    invitees: data,
    mutate,
  };
};

// 用户佣金收益
export const useCommissions = () => {
  const uid = rfStore.getRFState()?.userId;
  const url = `${baseUrl}/promotion/api/commissions`;
  const { data, mutate } = useSWR(
    uid ? url : null,
    async (url) =>
      await http
        .get<RFResponse<ResponseRebateCommission>>(url)
        .then((res) => res.data)
  );

  return {
    loading: !data,
    commissions: data,
    mutate,
  };
};

// 获取邀请自己的人的信息
const getShareCodeInviteMyself = async () => {
  const url = `${baseUrl}/promotion/api/invite/code/inviter`;
  try {
    const { code, message, data } = await http.get<RFResponseCommon<string>>(
      url
    );

    if (code !== 200) {
      throw Error(message);
    }

    return data;
  } catch (error) {
    console.log(error);
  }
};

const PullNewServices = {
  getOpportunityRecords,
  getPrizeRecords,
  getPrizeResult,
  getPrizeTimes,
  getShareCode,
  getOpenBrokerStatus,
  getMarqueeRecords,
  getInviter,
  getShareCodeInviteMyself,
  useGetInvitees,
  useCommissions,
  useGetShareCode,
};

export default PullNewServices;
